import { FC } from 'react';
import { Box } from '@qga/roo-ui/components';

import BookingAlert from 'components/BookingAlert/index';
import { DetailsBooking } from 'types';

interface FinalisingBookingMessageProps {
  booking: DetailsBooking;
}

const FinalisingBookingStateMessage: FC<FinalisingBookingMessageProps> = ({ booking }) => (
  <BookingAlert>
    <Box display={['block', 'inline']}>
      <strong>We’re finalising your booking.</strong>
    </Box>{' '}
    A confirmation email will be sent to {booking.travelArranger.email}
  </BookingAlert>
);

export default FinalisingBookingStateMessage;
